export const chartStyling = {
  size: 18,
  mirrorTicks: "ticks",
  marginLeft: 55,
  marginTop: 40,
  marginRight: 40,
  marginBottom: 55,
  borderRadius: 20,
  gridcolor: "grey",
  lcolor: "grey",
  bgColor: "#1e1f45",
  textColor: "white",
};

export const chartBgColor = {
  darkMode: {
    legendColor: "white",
    gridcolor: "grey",
    lcolor: "grey",
    bgColor: "#1e1f45",
    textColor: "white",
  },
  lightMode: {
    legendColor: "black",
    gridcolor: "black",
    lcolor: "black",
    bgColor: "white",
    textColor: "black",
  },
};
